import React from 'react';
import { Server } from '../../server/server';
import { checkNumber, getAssetImage } from '../util/util';
import './Modal.css'
import './SellTokensModal.css'
import { Database } from '../../server/database';
import AlertModal from './AlertModal';
import MessageModal from './MessageModal';
import { AppConfig } from '../AppConfig';

interface SellTokensModalProps {
  open: boolean,
  onClose: Function;
}

interface SellTokensModalState {
  quantity: number
  message: string;
  alert: string;
}

class SellTokensModal extends React.Component<SellTokensModalProps, SellTokensModalState> {
  protected tokensPerDollar:number = 100;
  protected coinsPerToken:number = 10;

  constructor(props: SellTokensModalProps) {
    super(props);
    this.state = this.getInitialState();
    this.onQuantity = this.onQuantity.bind(this);
    this.onSell = this.onSell.bind(this);
    this.onClose = this.onClose.bind(this);
  }

  getInitialState():any {
    return {
      quantity: 100,
      message: '',
      alert: ''
    };
  }

  onQuantity(e: React.FormEvent<HTMLInputElement>) {
    let value = e.currentTarget.value;
    if (!checkNumber(value)) 
      return;
    this.setState({ quantity: +value });
  }

  onSell() {
    if(this.state.quantity < 100) {
      this.setState({alert: 'The minimum number of tokens you can sell is 100.'});
      return;
    }

    this.setState({message: 'Processing....'});

    setTimeout(async () => {
      let response = await Server.user.sellTokens(this.state.quantity);
  
      if(response.success) 
        this.setState({message: '', alert: 'Sale successful!'});
      else
        this.setState({message: '', alert: response.message});
    }, 500);
  }

  onClose() {
    let state = this.getInitialState();
    this.setState(state);
    this.props.onClose();
  }

  renderPriceDiv(price:number, currency:string) {
    if(currency == 'usd') {
      return (
        <div className="shop-card-price">{'$' + price.toFixed(2)}</div>
      );
    }

    let icon = (currency == AppConfig.token.id) ? AppConfig.token.id : 'coin';

    return (
      <div className="shop-card-price">
        {price.toFixed(0)}&nbsp;<img className="shop-card-price-icon" src={'/assets/' + icon + '.png'} />
      </div>
    )
  }

  render() {
    if(!this.props.open) {
      return (<div></div>)
    }

    if(this.state.message)
      return (<MessageModal message={this.state.message} />)

    if(this.state.alert)
      return (<AlertModal message={this.state.alert} button="OK" onClose={this.onClose}/>);

    let tokenPrice = 1 / this.tokensPerDollar;
    let fees = Math.floor(this.state.quantity * 0.06);
    let total = (this.state.quantity - fees) * tokenPrice;

    return (
      <div className="modal open">
        <div className="modal-content" onClick={e => e.stopPropagation()}>
          <div className="sell-tokens-modal">
            <div style={{textAlign: 'center', fontSize: '1.1em'}}>Sell Tokens</div>
            <div className="sell-tokens-quantity-panel">
              <div className="sell-tokens-quantity-row">
                <div>Wallet Balance</div>
                {this.renderPriceDiv(Server.user.getTokenCount(), AppConfig.token.id)}
              </div>
              <div className="sell-tokens-quantity-row">
                <div>{AppConfig.token.symbol} Price</div>
                {this.renderPriceDiv(tokenPrice, 'usd')}
              </div>
            </div>
            <div className="sell-tokens-quantity-panel">
              <div className="sell-tokens-quantity-row">
                <div>Quantity to Sell</div>
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', columnGap: '5px'}}>
                  <div>
                    <input className="sell-tokens-quantity-input" value={this.state.quantity} onChange={this.onQuantity} />
                  </div>
                  <img className="shop-card-price-icon" src={'/assets/' + AppConfig.token.id + '.png'} />
                </div>
              </div>
              <div className="sell-tokens-quantity-row">
                <div>Fee (6%)</div>
                {this.renderPriceDiv(fees, AppConfig.token.id)}
              </div>
              <div className="sell-tokens-quantity-row" style={{color: 'white'}}>
                <div>Total</div>
                {this.renderPriceDiv(total, 'usd')}
              </div>
            </div>

            <div className="sell-tokens-button-panel">
              <button className="sell-tokens-cancel-button" onClick={this.onClose}>
                Cancel
              </button>
              <button onClick={this.onSell}>
                Sell
              </button>
            </div>

          </div>
        </div>
      </div>
    )
  }
}

export default SellTokensModal;
